import { Progress, Tag, Tooltip, Typography } from 'antd'
import React from 'react'
import { CensusUploadJobDto } from '../api/dto/census-upload-job.dto'
import { describeUploadStage } from '../utils/census-upload-job'

const { Text } = Typography

const PROCESSING_CELL_STYLE: React.CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  lineHeight: 'normal',
}

function CensusQueueStatusCell({ job }: { job: CensusUploadJobDto }) {
  const stage = describeUploadStage(job.stage)

  if (job.status === 'QUEUED') {
    return <Tag>Waiting to start</Tag>
  }

  if (job.status === 'PROCESSING') {
    return (
      // Grid cells inherit a 60px line height, which pushed the label onto the bar
      <div style={PROCESSING_CELL_STYLE}>
        <Progress percent={job.percent} size="small" status="active" />
        {stage && <Text className="textSm textGray">{stage}</Text>}
      </div>
    )
  }

  return (
    <div>
      <Tooltip title={job.errorMessage ?? 'The upload failed'}>
        <Tag color="error">Failed</Tag>
      </Tooltip>
      <Text className="textSm textGray">{`Stopped at ${job.percent}%`}</Text>
    </div>
  )
}

export default CensusQueueStatusCell
